<template>
  <footer>

    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
      <div class="border-t border-gray-200 py-8 text-sm text-gray-500 text-center sm:text-left"><span
          class="block sm:inline">© Центр интеллектуальных и творческих состязаний "Уникум",</span> <span
          class="block sm:inline">свидетельство 24 № 005087584</span></div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "PageFooter"
}
</script>

<style scoped>

</style>